<span *ngIf="orderTtlSeconds" class="d-flex clock-countdown justify-content-center">
  <span class="countdown-icon" style="width: 2.5rem"><i class="fas fa-regular fa-clock"></i></span>
  <span>{{'layout.header.countdown.label' | translate }}</span>
  <span class="text-right clock-label">{{orderTtlSeconds | timeParse:'S':'MINUTES_SECONDS' }}</span>
</span>